/**
 * jc-our-story.js
 * Upload to: Assets/jc-our-story.js
 */
(function () {
  'use strict';
  var els = document.querySelectorAll('.jcos-fade');
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('jcos-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('jcos-visible');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}());
